export default "__VITE_ASSET__DfzXSj$W__"